import React, { Component } from 'react';
import queryString from 'query-string';
import { Redirect } from 'react-router-dom/cjs/react-router-dom';

import { isEmailValid } from 'common/utility/helpers';
import { hasRoleAnonymous, hasRoleAdmin } from 'common/utility/userRoles';

import branch from 'client/core/branch';
import { SCREEN_ID_UTILITY_PROFIT_PARTNER_SIGN_UP } from 'client/constants/screenIds';

import withScreenId from 'client/helpers/withScreenId';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withLocationQuery from 'client/helpers/withLocationQuery';
import withScrollToTop from 'client/helpers/withScrollToTop';

import { getUserLandingPage } from 'client/helpers/allowedUtilityRoles';

import UtilityPartnerActions from 'client/actions/UtilityPartner';
import UtilityPartnerGroupActions from 'client/actions/UtilityPartnerGroup';

import UPHubspotWidget from 'client/components/UPHubspotWidget';
import UpSelfOnboarding from 'client/components/UPSelfOnboarding/UpSelfOnboarding';

@withTransitionHook
@withLocationQuery
@withScrollToTop
@withScreenId(SCREEN_ID_UTILITY_PROFIT_PARTNER_SIGN_UP)
@branch(({ locationQuery }) => {
  const cursors = {
    utilityUser: ['utilityUser'],
  };

  if (locationQuery.referrer) {
    cursors.referrer = ['utilityPartners', 'bySlug', locationQuery.referrer];
  }

  if (locationQuery.g) {
    cursors.utilityPartnerGroup = ['utilityPartnerGroups', 'byId', locationQuery.g];
  }

  return cursors;
})
class UtilityProfitPartnerSignUpPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Utility Profit | Sign Up',
  });

  static fetchData(match, inject) {
    const locationQuery = queryString.parse(inject.location.search);
    const promises = [];

    if (locationQuery.referrer) {
      promises.push(
        UtilityPartnerActions.getBySlug(inject, {
          slug: locationQuery.referrer,
        }),
      );
    }
    if (locationQuery.g) {
      promises.push(
        UtilityPartnerGroupActions.getById(inject, {
          id: parseInt(locationQuery.g, 10),
        }),
      );
    }

    return Promise.all(promises);
  }

  render() {
    const { utilityUser, referrer, locationQuery, utilityPartnerGroup } = this.props;

    const isAdminReferralFlow = hasRoleAdmin(utilityUser.roles) && locationQuery.referrerUserId;
    const emailToActivate = isEmailValid(locationQuery?.activate) ? locationQuery.activate : null;

    if (!hasRoleAnonymous(utilityUser.roles)) {
      if (emailToActivate) {
        return <Redirect to="/logout?next=utility-profit/signup" />;
      }
      if (!isAdminReferralFlow) {
        return <Redirect to={getUserLandingPage({ userRoles: utilityUser.roles })} />;
      }
    }

    return (
      <>
        <UpSelfOnboarding
          referrer={referrer}
          emailToActivate={emailToActivate}
          utilityPartnerGroup={utilityPartnerGroup}
          referrerUserId={locationQuery.referrerUserId}
        />
        <UPHubspotWidget />
      </>
    );
  }
}

UtilityProfitPartnerSignUpPage.displayName = 'UtilityProfitPartnerSignUpPage';

export default UtilityProfitPartnerSignUpPage;
